// Axios Instance - Pre-configured with security settings and interceptors

import axios from 'axios';
import { API_BASE_URLS, API_TIMEOUTS, getApiUrl } from '../config/api.config';
import { SECURE_REQUEST_CONFIG } from '../config/security.config';
import {
  requestSuccessInterceptor,
  requestErrorInterceptor,
} from '../interceptors/request.interceptor';
import {
  responseSuccessInterceptor,
  responseErrorInterceptor,
} from '../interceptors/response.interceptor';

// Main Axios instance
const axiosInstance = axios.create({
  baseURL: getApiUrl('primary'),
  timeout: API_TIMEOUTS.default,
  ...SECURE_REQUEST_CONFIG,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  requestSuccessInterceptor,
  requestErrorInterceptor
);
axiosInstance.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
);

// Upload instance - extended timeout for file uploads
export const uploadInstance = axios.create({
  baseURL: API_BASE_URLS.storage || getApiUrl('primary'),
  timeout: API_TIMEOUTS.upload,
  ...SECURE_REQUEST_CONFIG,
});

uploadInstance.interceptors.request.use(
  requestSuccessInterceptor,
  requestErrorInterceptor
);
uploadInstance.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
);

// Microsoft Graph API instance
export const msGraphInstance = axios.create({
  baseURL: API_BASE_URLS.msGraph,
  timeout: API_TIMEOUTS.default,
  ...SECURE_REQUEST_CONFIG,
  headers: {
    'Content-Type': 'application/json',
  },
});

msGraphInstance.interceptors.request.use(
  requestSuccessInterceptor,
  requestErrorInterceptor
);
msGraphInstance.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
);

// Long-running operations instance
export const longRunningInstance = axios.create({
  baseURL: getApiUrl('primary'),
  timeout: API_TIMEOUTS.longRunning,
  ...SECURE_REQUEST_CONFIG,
  headers: {
    'Content-Type': 'application/json',
  },
});

longRunningInstance.interceptors.request.use(
  requestSuccessInterceptor,
  requestErrorInterceptor
);
longRunningInstance.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
);

export default axiosInstance;
